














































import { Component, Prop, Vue } from "vue-property-decorator";
import { showError, showSuccess, showWarning } from "@/utils/Common";
import {
  MSG_ADD_SUCCESS,
  MSG_INVALID_PAGE,
  MSG_MODIFY_SUCCESS
} from "@/configs/Consts";

@Component
export default class ExpenseCategoryForm extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  categoryItem!: any;
 

  isEditCategory() {
    return this.categoryItem && this.categoryItem.id;
  }

  saveCategory() {
    const form = this.$refs.categoryForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      const categoryData = JSON.parse(JSON.stringify(this.categoryItem));
      this.$store
        .dispatch(
          this.isEditCategory() ? "expense/updateExpenseCategory" : "expense/addExpenseCategory",
          categoryData
        )
        .then(() => {
          this.$emit("update:expenseCategoryItem", {});
          showSuccess(this.isEditCategory() ? MSG_MODIFY_SUCCESS : MSG_ADD_SUCCESS);
          this.$emit("data-success");
        })
        .catch(({ message }) => showError(message));
    });
  }
}
